import { render, staticRenderFns } from "./GBMonth.vue?vue&type=template&id=3d945a8a&"
import script from "./GBMonth.vue?vue&type=script&lang=js&"
export * from "./GBMonth.vue?vue&type=script&lang=js&"
import style0 from "./GBMonth.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports